// Local translations
export const T = {
  en_GB: {
    riskScoringMatrix: "Risk Scoring Matrix",
    matrixDescription:
      "Click any cell to set a risk score (1-20). Lower scores = lower risk, higher scores = higher risk.",
    riskLevelTimeHorizon: "Risk Level / Time Horizon",
    setRiskScore: "Set Risk Score",
    enterScoreDescription: "Enter a risk score between 1 and 20 for this cell.",
    enterScoreHint: "Enter a score between 1 and 20 for this combination",
    scorePlaceholder: "1-20",
    currentScore: "Current score:",
    cancel: "Cancel",
    save: "Save",
    validationError: "Validation Error",
    validationMessage: "Please enter a score between 1 and 20",
    ok: "OK",
    error: "Error",
    failedToUpdateScore: "Failed to update score",
    riskScoreAriaLabel: "Risk score cell for",
  },
  nb_NO: {
    riskScoringMatrix: "Risikoscorematrise",
    matrixDescription:
      "Klikk på en celle for å sette en risikoscore (1-20). Lavere score = lavere risiko, høyere score = høyere risiko.",
    riskLevelTimeHorizon: "Risikonivå / Tidshorisont",
    setRiskScore: "Sett risikoscore",
    enterScoreDescription: "Skriv inn en risikoscore mellom 1 og 20 for denne cellen.",
    enterScoreHint: "Skriv inn en score mellom 1 og 20 for denne kombinasjonen",
    scorePlaceholder: "1-20",
    currentScore: "Gjeldende score:",
    cancel: "Avbryt",
    save: "Lagre",
    validationError: "Valideringsfeil",
    validationMessage: "Vennligst skriv inn en score mellom 1 og 20",
    ok: "OK",
    error: "Feil",
    failedToUpdateScore: "Kunne ikke oppdatere score",
    riskScoreAriaLabel: "Risikoscore-celle for",
  },
} as const;
